<!-- 预付款历史 -->
<template>
  <div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>

    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
        </vSearch>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" size="mini" stripe :data="returnData.list" :height="tableHeight" border ref="mainTable" :show-summary="true" :summary-method="getSummaries" style="width: 100%"
        @selection-change="handleSelectionChange" @current-change="handleCurrentChange" highlight-current-row>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
              </span>
            </span>
            <span v-else-if="tableValye.fieldType == 'dateTime'">
              <span v-if="scope.row[tableValye.entityField]">
                {{$common.getLocalTime(scope.row[tableValye.entityField], true)}}
              </span>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'isOrder'">
              {{scope.row.isOrder == 1 ? '是' : '否'}}
            </el-tag>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
            </span>
            <span v-else-if="tableValye.fieldType == 'formatter'">
              <el-tag size="mini">{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
            </span>
            <span v-else>
              {{scope.row[tableValye.entityField]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel1" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
    <el-dialog title="记账" v-if="bookKeepShow" :visible.sync="bookKeepShow" width="60%">
      <div>
        <el-form @submit.native.prevent inline :model="sendDataInfo" ref="sendDataInfo" class="demo-form-inline" size="mini" :show-message="false">
          <el-form-item label="账簿编号" prop="abookCode" :rules="[{required: true,trigger: ['blur', 'change']}]">
            <el-input clearable v-model="sendDataInfo.abookCode" @keyup.enter.native="openSearch1('336844454858752', 'abookCode','abookCode,abookId,abookName')">
              <el-button slot="append" @click="openSearch1('336844454858752', 'abookCode','abookCode,abookId,abookName')" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="账簿名称">
            <el-input clearable v-model="sendDataInfo.abookName" disabled></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center;margin-top:20px;">
          <el-button type="primary" plain @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      seTitle: "",
      DialogVisible: false,
      DialogVisible1: false,
      bookKeepShow: false,
      seWidth: "",
      seId: "",
      fil: "",
      getRequestData: {
        smId: "",
        smName: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
        "creater": "",
        "ormId": "",
        applyState: "",
        coName: '',
        coId: ''
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      multipleSelection: [],
      pageShowData: [],
      selectedDataIndex: 0,
      parentSearchData: {},
      requesUrl: '',
      sendDataInfo: {
        abookCode: "",
        abookId: "",
        abookName: "",
        ids: []
      },
      totalField: [],
      ormId: '',

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.psrgmBuycusName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.psrgmBuycus = "";
        }
      },
      deep: true,
    },
    "getRequestData.coName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.coId = "";
        }
      },
      deep: true,
    },
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.smId = "";
        }
      },
      deep: true,
    },
    "getRequestData.abookCode": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.abookId = "";
          this.getRequestData.abookName = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // 自定义合计字段
    getSummaries(param) {
      const {
        columns,
        data
      } = param;
      console.log(columns, data)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (this.totalField.includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.toDecimal(prev + curr);
              } else {
                return this.toDecimal(prev)
              }
            }, 0);
            sums[index] = this.$common.getDecimalInfo(3, sums[index])
            // sums[index] = sums[index].toFixed(2)
            // sums[index] += ' 元';
          } else {
            sums[index] = 'N/A';
          }
        } else {
          sums[index] = ''
        }
      });

      return sums;
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return;
      }
      f = Math.round(x * 100) / 100;
      return f;
    },
    initActionBox(sendDataInfo) {
      this.$confirm("确定取消新增吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.init();
          this.$refs[sendDataInfo].resetFields();
          this.bookKeepShow = false;
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '取消关闭'
          // });
        });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "ids") {
          this.sendDataInfo[key] = [];
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      // this.sendDataInfo.totalCount = 0;
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.subFn()
        } else {
          this.$message({
            message: '请完善必填项！',
            type: "error",
          });
          return false;
        }
      });
    },
    subFn() {
      this.$confirm("确定将选中记账吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.sub()
        })
        .catch(() => { });
    },
    async sub() {
      console.log('registerBatchBookkeeping', this.sendDataInfo);
      let responseData = await this.$http.registerBatchBookkeeping(this.sendDataInfo);
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.init()
        this.$refs['sendDataInfo'].resetFields();
        this.bookKeepShow = false
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 勾选明细
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleCurrentChange(val) {
      console.log(val.applyState);
      if (val.applyState != 0) {
        this.disbleshow = false;
      } else {
        this.disbleshow = true;
      }
      console.log(this.disbleshow);
    },
    //选择最后日期
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch1(sId, type, sField) {
      this.seId = sId;
      this.sField = sField
      this.DialogVisible1 = true;
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 赋值字段
    paramValue1(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
    },
    changeInputModel1(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible1 = false;
        this.paramValue1(val)
      }
    },
    // 检索Id, 索引(表格中), 标识
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.seId = sId;
      this.sField = sField
      this.DialogVisible = true;
      this.parentSearchData[type] = this.getRequestData[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    // 子组件触发
    drawerCancel() {
      this.showStatus = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }
    },
    getSeData(val) {
      console.log(val);
      if (this.fil == "smId") {
        this.getRequestData.smName = val.smName;
        this.getRequestData.smId = val.smId;
      } else if (this.fil == "opmId") {
        this.getRequestData.opmId = val.opmId;
        this.getRequestData.opmName = val.opmName;
      }
      this.DialogVisible = false;
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    isShowData(name, value) {
      console.log(name);
      switch (name) {
        case "psrgmBuycus":
          var dataInfo = sessionStorage.getItem("selectSupplierData");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.psrgmBuycus = dataInfo.smId;
            this.getRequestData.psrgmBuycusName = dataInfo.smName;
          }
          break;
        default:
          this.sendDataInfo[name] = value;
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      });
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result;
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
          if (item.fieldType == 'number') {
            this.totalField.push(item.entityField)
          }
        })
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    clear(val) {
      if (val) {
        var arr = val.split(",")
        arr.forEach(item => {
          this.$set(this.getRequestData, item, "")
        })
      }
    },
    // 动作集合
    actionSet(actionData) {
      console.log('actionSet', actionData);
      if (actionData.actionType != 15 && actionData.actionType != 4) {
        if (this.returnData.list.length < 1) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
        if (this.multipleSelection.length < 1) {
          this.$message({
            message: "请先选中要操作的数据",
            type: "error",
          });
          return false;
        }
      }
      var dataInfo = this.multipleSelection[this.multipleSelection.length - 1];

      switch (actionData.actionType) {
        case 0:
          this.bookKeepClick()
          break;
        case 4:
          this.exportData()
          break;
        case 5:
          this.$refs["processAuditAction"].openBox(1, dataInfo.businessId);
          break;
        case 7:
          this.backOff()
          break;
      }
    },
    //  导出
    exportData() {
      window.location.href = this.requesUrl + '/preApply/exportData?ormId=' + String(this.ormId) + '&smId=' + this.getRequestData.smId
        + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
        + '&applyState=' + this.getRequestData.applyState + '&coId=' + this.getRequestData.coId;
    },
    backOff() {
      var dataInfo = this.multipleSelection[this.multipleSelection.length - 1];
      this.$confirm("确定回退订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {
            ids: [dataInfo.businessId],
          };
          let responseData = await this.$http.preApplyGoBack(data);
          if (responseData.status == 200) {
            this.$message({
              message: responseData.message,
              type: "success",
            });
            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },
    bookKeepClick() {
      this.sendDataInfo.ids = []
      this.multipleSelection.forEach(v => {
        this.sendDataInfo.ids.push(v.businessId)
      })
      this.bookKeepShow = true
      console.log('bookKeepIds', this.sendDataInfo);
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },

    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.smName == "") {
        this.getRequestData.smId = "";
      }

      let responseData = await this.$http.preApplyQueryHis(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
        this.$nextTick(() => {
          this.$refs.mainTable.doLayout()
        })
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
//获取状态
    getIsGsp(str, val) {
      try {
        if (str.indexOf('[') === -1) return val
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr ? newStr : val
      } catch (ex) {
        return val
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.requesUrl = this.$store.getters.getConfig.requestUrl;
    this.ormId = sessionStorage.getItem('ormId')
    this.getPageInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight(); this.$store.state.tableNum++ }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>